export const TEMPLATE_STATUSES = {
  draft: 0,
  active: 1,
  deleted: -1
};

export const AVAILABLE_FORM_MODES = ['create', 'edit', 'view'];
